import { render, staticRenderFns } from "./ColorProfile.vue?vue&type=template&id=0d1a2b10&"
import script from "./ColorProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./ColorProfile.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports